import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import Button from "../../components/Button";
import Dropdown from "../../components/Dropdown";
import LocationCard from "../../components/LocationCard";
import PaddingContainer from "../../components/PaddingContainer";
import TabsContainer from "../../components/TabsContainer";
import { AddCircleIcon } from "../../constant";
import AreYouSureModal from "../../modals/AreYouSureModal";
import AddOrEditLocationModal from "../../modals/Locations/AddOrEditLocationsModal";
import useApi from "../../useApi";
import classes from "./Locations.module.css";
import SearchInput from "../../components/SearchInput";
import useDebounce from "../../customHooks/useDebounce";
import { useDispatch } from "react-redux";
import { setPageTitle, setPageLink } from "../../store/pageSlice";
const SmallHeading = ({ label }) => {
  return <h2 className={classes.smallHeading}>{label}</h2>;
};
const options = [];

const Locations = () => {

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("")
  const { getAdminLocations, addLocation, updateLocation } = useApi();
  const [selectedItem, setSelectedItem] = useState(null);
  const [showAddOrEitLocationModal, setShowAddOrEitLocationModal] =
    useState(false);
  const [showAreYouSureModal, setShowAreYouSureModal] = useState(false);
  const [locations, setLocations] = useState([]);

  const navbarActions = [
    // { label: "View Payments", type: "white", onClick: () => {} },
    // {
    //   label: "View Booking",
    //   type: "white",
    //   onClick: () => {},
    // },
    {
      label: "Add Location",
      type: "primary",
      onClick: () => {
        setSelectedItem(null);
        setShowAddOrEitLocationModal(true);
      },
      icon: <AddCircleIcon />,
    },
  ];
  const debounceSearch = useDebounce(search, 500);
  const getAllLocations = async (params) => {
    const response = await getAdminLocations(params);
    if (response?.data?.headers?.error === 200) {
      setLocations(response?.data?.body?.items?.filter(item => item?.active));
    } else {
      toast.error(response?.data?.headers?.message);
    }
  };
  const addLocationApi = async (params) => {
    setLoading(true);
    const res = await addLocation(params);
    if (res?.data?.headers?.error === 200) {
      toast.success("Location Added Successfully");
      setLocations((prev) => [res?.data?.body, ...prev]);
      setShowAddOrEitLocationModal(false);
    } else {
      toast.error(res?.data?.headers?.message)
    }
    setLoading(false);
  };

  const updateLocationApi = async (params) => {
    setLoading(true);
    const res = await updateLocation(params);
    if (res?.data?.headers?.error === 200) {
      toast.success(
        `Location ${params?.delete ? "Deleted" : "Updated"} Successfully`
      );
      setLocations((prev) => {
        if (params?.delete) {
          return prev.filter((item) => item.locationId !== params.locationId);
        } else {
          return prev.map((item) =>
            item.locationId === params.locationId ? params : item
          );
        }
      });
      setShowAddOrEitLocationModal(false);
      setShowAreYouSureModal(false);
    }
    setLoading(false);
  };

  const onDeleteLocation = (data) => {
    setShowAreYouSureModal(true);
    setSelectedItem(data);
  };
  useEffect(() => {
    getAllLocations({
      id: null,
      search: debounceSearch,
      pageNumber: 1,
      pageSize: 100000000,
      showInactive: true,
      showUpcoming: true,
    });
  }, [debounceSearch]);
  useEffect(() => {
    dispatch(setPageTitle("Locations"));
    dispatch(setPageLink(""));
  }, []);
  const onEditLocation = (data) => {
    setShowAddOrEitLocationModal(true);
    setSelectedItem(data);
  };
  console.log("config", locations);

  return (
    <>
      <PaddingContainer>
        <div className={classes.wrapper}>
          <nav className={classes.locationsHeader}>
            <h1 className={classes.title}>List of Locations</h1>
            <TabsContainer
              tabs={
                <>
                  <div className={classes.navbarActions}>
                    {/* <Dropdown
                      className={classes.bgWhite}
                      placeholder={"Filter"}
                      options={options}
                    /> */}

                    <SearchInput value={search} onChange={setSearch} placeholder="Search Location" />

                    {navbarActions?.map(
                      ({ type, label, variant, icon, onClick }) => {
                        return (
                          <Button
                            variant={type}
                            className={classes.headerBtn}
                            leftIcon={icon}
                            label={label}
                            onClick={onClick}
                          />
                        );
                      }
                    )}
                  </div>
                </>
              }
            />
          </nav>

          <section className={classes.locationsList}>
            <SmallHeading label="All Locations" />
            <Row>
              {locations?.map((location) => (
                <Col key={location?.locationId} xs={12} md={6} lg={4}>
                  <LocationCard
                    onDelete={onDeleteLocation}
                    onEdit={onEditLocation}
                    location={location}
                  />
                </Col>
              ))}
            </Row>
          </section>
        </div>
      </PaddingContainer>
      {showAddOrEitLocationModal && (
        <AddOrEditLocationModal
          data={selectedItem}
          onEdit={onEditLocation}
          show={showAddOrEitLocationModal}
          setShow={setShowAddOrEitLocationModal}
          onSubmit={selectedItem ? updateLocationApi : addLocationApi}
        />
      )}
      {showAreYouSureModal && (
        <AreYouSureModal
          title="Location"
          data={selectedItem?.locationName}
          show={showAreYouSureModal}
          setShow={setShowAreYouSureModal}
          onConfirm={() => {
            updateLocationApi({
              "locationId": selectedItem?.locationId,
              "locationAddress": null,
              "locationCity": null,
              "locationCountry": null,
              "countryCode": null,
              "cellNumber": null,
              "delete": true
            })
          }}
        />
      )}
    </>
  );
};

export default Locations;
